import { TFunction } from 'i18next';
import { Form } from 'react-bootstrap';
import { FieldErrors, FieldValues, Path, UseFormRegister } from 'react-hook-form';

interface Props<T extends FieldValues> {
  content: string;
  errors: FieldErrors<T>;
  name: Path<T>;
  register: UseFormRegister<T>;
  required?: boolean;
  t: TFunction;
}

export const CheckboxField = <T extends FieldValues>({
  content,
  errors,
  name,
  register,
}: Props<T>) => (
  <label className="flex flex-1 items-start gap-2 font-normal max-w-(--breakpoint-md) lg:max-w-(--breakpoint-lg)">
    <Form.Check id={name} type="checkbox" {...register(name)} isInvalid={!!errors[name]} />
    <p className="small">
      {content}
      {/* {required && (*/}
      {/*  <span className="small text-primary text-nowrap"> [{t('fields.required')}]</span>*/}
      {/* )}*/}
    </p>
  </label>
);
